(() => {
  if (customElements.get('sayuri-cart-timer')) return;
  const key = 'sayuri-cart-timer-v1';
  let deadline = 0;
  try { deadline = Number(sessionStorage.getItem(key)) || 0; } catch (_) {}
  const persist = () => { try { if (deadline) sessionStorage.setItem(key, String(deadline)); else sessionStorage.removeItem(key); } catch (_) {} };
  customElements.define('sayuri-cart-timer', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.count = Number(this.dataset.count) || 0;
      this.clock = this.querySelector('[data-timer-clock]');
      this.label = this.querySelector('[data-timer-label]');
      this.note = this.querySelector('[data-timer-note]');
      const options = {signal:this.events.signal};
      document.addEventListener('theme:cart:change', event => {
        if (!Number.isFinite(Number(event.detail?.cartCount))) return;
        this.count = Number(event.detail.cartCount);
        this.sync();
      }, options);
      document.addEventListener('theme:cart-drawer:open', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.render(), options);
      this.sync();
      this.tick = setInterval(() => this.render(), 1000);
    }
    sync() {
      if (!this.count) { deadline = 0; persist(); this.hidden = true; return; }
      if (!deadline) { deadline = Date.now() + 10 * 60 * 1000; persist(); }
      this.hidden = false;
      this.render();
    }
    render() {
      if (!this.count || !deadline) return;
      const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      this.clock.textContent = `${String(Math.floor(seconds / 60)).padStart(2,'0')}:${String(seconds % 60).padStart(2,'0')}`;
      this.label.textContent = seconds ? 'カートの残り時間：' : '引き続きお買い物いただけます';
      this.note.hidden = !seconds;
    }
    disconnectedCallback() { clearInterval(this.tick); this.events?.abort(); }
  });
})();
